import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryPool} from "@/service/pool.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";

export const ViewPool: FC = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: poolData, isLoading: poolLoading} = useQueryPool({id: drawerId!}, isNumber(drawerId))
    const pool = poolData?.data
    return <> <ResultWrapper isLoading={poolLoading} isEmpty={isEmpty(pool)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'客户名称'} content={pool?.poolName}/>
                <GridItem title={'联系人'} content={pool?.contact}/>
                <GridItem title={'联系电话'} content={pool?.mobile}/>
                <GridItem title={'所在地区'} content={pool?.location}/>
                <GridItem minHeight={'48px'} size={12} title={'备注'} content={pool?.remark}/>
                <GridItem title={'创建人'} content={pool?.creator}/>
                <GridItem title={'创建时间'} content={formatTime("M", pool?.createdAt)}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}